<div class="content"> 
  <div *ngIf="!loading && (!spareParts || (spareParts.Packages.length==0 && spareParts.SpareParts.length==0))">
    There are no spare parts for the given asset
  </div>
  <mat-accordion *ngIf="!loading && spareParts">
    <mat-expansion-panel *ngIf="spareParts.SpareParts.length>0" [expanded]="spareParts.Packages.length==0">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h4>
            General parts
          </h4>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <spare-parts-list [spareParts]="spareParts.SpareParts" />
    </mat-expansion-panel>
  
    <mat-expansion-panel *ngFor="let package of spareParts.Packages">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h4>
            {{ package.Description | default:"Not named package"}}
          </h4>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <spare-parts-list [sparePartsPackage]="package" />
    </mat-expansion-panel>
  </mat-accordion>
</div> 

<!-- <loading-bar *ngIf="loading" />

<h3 *ngIf="!loading && (!spareParts || (spareParts.Packages.length==0 && spareParts.SpareParts.length==0))">
  There are no spare parts for the given asset
</h3>

<mat-accordion *ngIf="!loading && spareParts">
  <mat-expansion-panel *ngIf="spareParts.SpareParts.length>0" [expanded]="spareParts.Packages.length==0">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h4>
          General parts
        </h4>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <spare-parts-list [spareParts]="spareParts.SpareParts" />
  </mat-expansion-panel>

  <mat-expansion-panel *ngFor="let package of spareParts.Packages">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h4>
          {{ package.Description | default:"Not named package"}}
        </h4>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <spare-parts-list [sparePartsPackage]="package" />
  </mat-expansion-panel>
</mat-accordion> -->